<script>
import _ from "lodash";
import Multiselect from 'vue-multiselect'

export default({
  name: "rfq-statewide-add-parts",
  props: {
    value: {}
  },
  data() {
    return{
      isDonutActive: false,
      isDonutActive2: false,
      makes: [
        'Alfa Romeo', 'Audi', 'Bentley',
        'BMW', 'Cupra', 'Chrysler',
        'Fiat', 'Haval', 'Holden',
        'Isuzu', 'Jac', 'Jaguar',
        'Jeep', 'Kia', 'Land-Rover',
        'Lexus', 'Mazda', 'Mercedes-Benz',
        'Mini', 'Mitsubishi', 'MG',
        'Nissan', 'Polestar', 'Porsche',
        'RAM', 'Renault', 'SsangYong',
        'Suzuki', 'Toyota', 'Volkswagen',
        'Volvo', 'McLaren', 'Aston Martin',
        'Lamborghini', 'Lotus', 'Ferrari',
        'Abarth', 'Pagani', '3M',
        'Brabus', 'Ppg', 'Sikkens',
      ],
      isFoundPrtNbrMatch: false,
    }
  },
  components: {
    Multiselect,
  },
  computed: {
    isDisabledAddToQuoteBtn () {
      return !(!_.isEmpty(this.value.description) || !_.isEmpty(this.value.partNumber)) || _.isEmpty(this.value.make) || _.isEmpty(this.value.vinVehicle)
    },
    showWarningEmptyVinVehicle(){
      return ((!_.isEmpty(this.value.description) || !_.isEmpty(this.value.partNumber)) && _.isEmpty(this.value.vinVehicle))
    }
  },
  created() {
    this.debouncedSearchPrtNbr = _.debounce(this.searchPrtNbr, 500)
  },
  methods: {
    upperCase (field) {
      this[field] = _.toUpper(this[field])
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async searchPrtNbr() {
      this.isDonutActive = true
      await this.sleep(1000)
      if (this.value.partNumber == '6n971627a') {
        this.isFoundPrtNbrMatch = true
      } else {
        this.isFoundPrtNbrMatch = false
      }
      this.isDonutActive = false
      return true
    },
    addToQuoteList() {

      if ((!_.isEmpty(this.value.description) || !_.isEmpty(this.value.partNumber)) && !_.isEmpty(this.value.make) && !_.isEmpty(this.value.vinVehicle)){
        let obj = {
          partDescription: _.cloneDeep(this.value.description),
          partNumber: _.cloneDeep(this.value.partNumber)
        }

        if (this.value.partNumber == '6n971627a') {
          obj = { partDescription: 'Fuel Injector Connector', partNumber: _.cloneDeep(this.value.partNumber), isStock: true, }
        }

        this.value.parts.push(obj)
        this.value.description = ''
        this.value.partNumber = ''
        this.isFoundPrtNbrMatch = false
        this.isDonutActive=false;
        return true
      }
    },
  },
})
</script>

<template>
  <div class="d-flex">
    <div class="wrapper-statewide">
      <div class="body-block d-flex">
        <div class="body-block-left">
          <div class="body-block-left-title">Vehicle Information</div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Make
            </div>
            <div class="body-block-left-item-input">
              <multiselect
                  v-model="value.make"
                  :options="makes"
                  style="width: 100%; text-transform: uppercase;"
                  :allowEmpty="false"
                  :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Vehicle VIN <br>
            </div>
            <div class="body-block-left-item-input d-flex">
              <input v-model="value.vinVehicle" @change="upperCase('vinVehicle')" type="text" style="width: 100%; text-transform: uppercase;" :class="{'red-blinker':showWarningEmptyVinVehicle && value.vinVehicle==''}">
              <div>
                <i  v-if="false" @click="$emit('openCameraVin')" class='bx bxs-camera'></i> <!-- //ToDo Temp -->
              </div>
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Estimate Number
            </div>
            <div class="body-block-left-item-input d-flex">
              <input type="text" v-model="value.QPNumber" @change="upperCase('QPNumber')" style=" text-transform: uppercase;">
            </div>
          </div>
          <div class="d-flex" style="margin-top: 40px; padding-top: 10px; border-top: 1px solid rgba(0, 0, 0, .25); margin-right: 20px; justify-content: space-between">
            <div class="body-block-left-title" >Create a Parts List</div>
            <div v-if="value.parts.length > 0" class="body-block-left-mobile-num-parts">{{ value.parts.length }}</div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Add Part Description
            </div>
            <div class="body-block-left-item-input d-flex">
              <input type="text" v-model="value.description" @change="upperCase('description')" style=" text-transform: uppercase;">
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name">
              Add Part Number
            </div>
            <div class="body-block-left-item-input d-flex">
              <input type="text" ref="partNumber" v-model="value.partNumber" @change="upperCase('partNumber')" @input="debouncedSearchPrtNbr" style="padding-right: 27px;  text-transform: uppercase;">
              <div v-if="value.partNumber.length > 0 && isDonutActive">
                <div style="text-align: center; margin: 50px auto">
                  <div class="donut"></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div v-if="isFoundPrtNbrMatch" class="d-flex body-block-left-item">
              <div class="body-block-left-item-name">
                Available at <br>
                <span>
                Locating your nearest <br>
                Parts dealership.
              </span>
                <div>
                  Shop with Confidence <br>
                  <span>Your information Safe</span>
                </div>
                <div>
                  Manufacturer Warranty <br>
                  <span>Minimum of 12 Months</span>
                </div>
              </div>
              <div class="available-right-block">
                <div class="body-block-left-item-info">
                  <div>
                    <img src="../../../../../public/img/auto-logo/audi.png" height="50" width="50">
                  </div>
                  <div class="body-block-left-item-info-title">
                    Fuel Injector Connector
                  </div>
                  <div class="body-block-left-item-info-availability">
                    Stock Availability
                    <span v-if="true" style="color: #00af4f; margin-left: 10px">In stock</span>
                    <span v-if="false" style="color: #fd0000; margin-left: 10px">Get Price & latest Stock quote</span>
                  </div>
                  <div class="body-block-left-item-info-qty">
                    Stock Qty <span style="margin-left: 55px">10 +</span>
                  </div>
                  <div class="body-block-left-item-info-dealership">
                    Your Dealership
                  </div>
                  <div class="body-block-left-item-info-name">
                    AUDI - Zagame Automotive
                  </div>
                  <div class="body-block-left-item-info-num">
                    Tullmarine - 3043
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex body-block-left-item">
            <div class="body-block-left-item-name" style="width: 40%">

            </div>
            <div class="body-block-left-item-input" style="width: 60%; height: 100px">
              <button @click="addToQuoteList" class="btn btn-add-quote" :class="{'disabled': isDisabledAddToQuoteBtn}" style="width: 100%;">Add to Quote List</button>
              <button v-if="isFoundPrtNbrMatch" @click="value.partNumber = ''; isFoundPrtNbrMatch = false; $refs.partNumber.focus()" class="btn btn-add-quote" style="width: 100%; margin-top: 10px; background-color: #333f4f; border-color: #333f4f;">Search Again</button>
            </div>
          </div>

        </div>
        <div class="body-block-right">
          <div class="body-block-right-title"  style="color: #562b77;">Parts List</div>
          <div class="body-block-right-subtitle">
            The parts list below will be sent to the dealership for a Price and Latest Stock quote.
          </div>

          <div v-if="value.parts.length > 0" class="table-body-block-right" :class="{'gray-table': false}">
            <div class="table-body-block-right-head d-flex">
              <div class="table-body-block-right-title" style="flex-grow: 1;">Part Description</div>
              <div class="table-body-block-right-title" style="width: 70px;">Qty</div>
              <div class="" style="width: 26px"></div>
              <div  class="table-body-block-right-title" style="width: 40px"></div>
            </div>
            <div class="table-body-block-right-body">
              <div v-for="(part, index) in value.parts" class="d-flex table-body-block-right-item" style="margin-bottom: 5px">
                <div style="flex-grow: 1;  text-transform: uppercase;">
                  <input :value="(part.partDescription?.length>0 && part.partNumber?.length>0)?(part.partDescription +' - '+ part.partNumber):(part.partDescription)?part.partDescription:part.partNumber  " :disabled="true" type="text" style="width: 100%; font-size: 11px; color:black; text-transform: uppercase;">
                </div>
                <div style="width: 70px; margin: 0 5px">
                  <input type="number" min="0" value="1" class="qty">
                </div>
                <div class=""
                     v-if="false && part.isStock"
                     style="width: 67px; background-color: rgb(0, 176, 80); color: white; border-radius: 6px; height: 32px; display: flex; align-items: center; justify-content: center; margin-right: 0px;">
                  In Stock
                </div>
                <div v-else-if="false"  >
                  <i @click="$emit('openCameraParts')" class='bx bxs-camera' style="margin-left: 0"></i>  <!-- //ToDo Temp -->
                </div>
                <div  class="table-body-block-right-item-icon d-flex" style="width: 50px">
                  <i @click="value.parts.splice(index, 1)" class='bx bx-trash' style="color: #c45408; cursor: pointer;"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="body-block-left-item" style="margin-top: 10px; height: 100px; position: absolute; bottom: 0;">
            <button
                @click="$emit('nextPage')"
                v-if="value.parts.length"
                style="width: calc(100% - 20px); min-width: 180px"
                class="btn btn-add-quote">Next</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.body-block-left-mobile-num-parts{
  display: none;
}
.body-block-left{
  width: 50%;
}
.body-block-right{
  width: 50%;
}
.right-banner{
  margin-top: 30px;
  width: 230px;
  font-size: 20px;
  position: sticky;
  top: 20px;
  height: 100%;
}
.right-banner-item-purple{
  background-color: #562a78;
  color: #fdcb2d;
  border-radius: 5px;
  font-weight: 600;
  padding: 20px;
  text-align: center;
}
.right-banner-item-grey{
  background-color: #d7d7d7;
  color: rgb(88, 43, 121);
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  font-weight: 600;
}
.right-banner-item-white{
  font-weight: 400;
  padding: 40px 20px;
  font-size: 16px;
}
.right-banner-item-white-elem{
  margin-bottom: 30px;
}
.right-banner-item-white-elem-title{
  font-weight: 800;
}
.gray-table,
.gray-table input,
.gray-table i{
  color: #bfbfbf !important;
}
.available-right-block{
  width: 60%;
}
.body-block-left-item-name{
  width: 40%;
}
.body-block-left-item-input{
  width: 60%;
}
@keyframes donut-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.donut {
  position: absolute;
  top: 7px;
  right: 22px;
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #7983ff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: donut-spin 1.2s linear infinite;
}
.donut2 {
  position: absolute;
  top: 16px;
  right: 10px;
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #7983ff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: donut-spin 1.2s linear infinite;
}
.body-block-left-item-info-title{
  font-size: 15px;
  color: #6e309e;
  margin-bottom: 5px;
}
.body-block-left-item-info-name{
  color: #6e309e;
}
.body-block-left-item-info-num{
  font-weight: 400;
}
.body-block-left-item-info-availability,
.body-block-left-item-info-qty{
  font-weight: 500;
}
.body-block-left-item-info-qty{
  border-bottom: 1px solid rgba(0, 0, 0, .25);
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.body-block-left-item-info{
  border: 2px solid rgba(0, 0, 0, .25);
  margin: 0 15px;
  height: 100%;
  padding: 0px 15px 15px 15px;
  border-radius: 3px;
}
.body-block-left-item-name div span{
  margin-top: 0;
  font-size: 13px;
}
.body-block-left-item-name div{
  margin-top: 15px;
  font-size: 13px;
}
.input-capricorn-num{
  height: 32px;
  width: calc(100% - 100px);
  margin-top: 10px;
  border: 2px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
}
.input-capricorn-num.active{
  border: 2px solid #6e309e;
}
.btn-block-text{
  margin-top: 20px;
  font-size: 16px;
  color: #6e309e;
  font-weight: 600;
}
.body-block-right-title-error,
.body-block-right-title-text{
  font-weight: 600;
  display: block;
  margin-top: 5px;
  font-size: 15px;
}
.body-block-right-title-error{
  color: red;
}
.block-left-dealer{
  margin-top: 10px;
  border: 2px solid #d7d7d7;
  border-radius: 5px;
  padding: 10px 20px;
  width: calc(100% - 100px)
}
.block-left-dealer-title{
  font-weight: 600;
  font-size: 15px;
}
.block-left-dealer-name{
  font-weight: 600;
  font-size: 15px;
  margin-top: 5px;
  color: rgb(110, 48, 158);
}
.block-left-dealer-info{
  font-weight: 400;
  font-size: 15px;
  margin-top: 5px;
}
.body-block-right-subtitle span{
  font-weight: 600;
}
.body-block-right{
  position: relative;
  min-width: 330px;
}
.table-body-block-right-title{
  font-weight: 700;
  font-size: 15px;
}
.table-body-block-right-item .qty{
  width: 60px;
}
.body-block-right input{
  height: 32px;
  padding: 5px 5px 5px 10px;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}
.table-body-block-right-body{
  margin-top: 10px;
}
.table-body-block-right-head{
  margin-top: 25px;
}
.body-block-left-item-input >>> .multiselect__content-wrapper{
  z-index: 99999;
}
.body-block-left-item-input >>> .multiselect__content-wrapper ul li span{
  text-transform: uppercase;
}
.body-block-left-item{
  margin-top: 10px;
}
.wrapper-statewide{
  font-family: Roboto;
  font-weight: 900;
  margin: 50px auto;
  width: 930px;
}
.header-block{
  font-size: 25px;
  color: black;
  justify-content: space-between;
}
.header-auth{
  margin-top: 40px;
}
.header-line{
  background-color: rgb(227, 228, 231);
  height: 10px;
  border-radius: 5px;
  margin: 60px 45px 0;
  width: 250px;
}
.header-title{
  font-size: 19px;
  text-align: center;
  justify-content: space-between;
  margin-top: 18px;
  font-weight: 700;
}
.header-title-item.active{
  color: rgb(28, 31, 57);
}
.header-title-item{
  color: rgb(128, 130, 134);
}
.body-block{
  padding-top: 25px;
  border-top: 1px solid rgba(0, 0, 0, .25);
  overflow-x: auto;
  overflow-y: hidden;
}
.body-block-left{
  border-right: 5px solid rgba(128, 128, 128, 0.4);
  margin-right: 20px;
  min-width: 380px;
}
.body-block-right-title{
  font-size: 19px;
}
.body-block-left-item-name{
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  padding-top: 6px;
}
.body-block-left-item-name span{
  font-weight: 400;
  font-size: 14px;
  margin-top: 10px;
  display: block;
}
.body-block-left-title{
  margin-bottom: 25px;
  font-size: 19px;
}
.body-block-left-item-input{
  padding-right: 15px;
  padding-left: 15px;
  height: 32px;
  position: relative;
}
.body-block-left-item-input >>> .multiselect__tags{
  border: 2px solid rgba(0, 0, 0, .25);
}
.body-block-left-item-input input{
  padding: 5px 10px;
  width: 100%;
  position: relative;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}
.body-block-capricon-number-input{
  height: 32px;
  position: relative;
}
.body-block-capricon-number-input input{
  padding: 5px 10px;
  width: 100%;
  position: relative;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}
.btn-add-quote{
  padding: 5px 10px;
  width: 294px;
  height: 42px;
  border: 2px solid #6f309f;
  background-color: #6f309f;
  border-radius: 3px;
  color: white;
  font-weight: 900;
  cursor: pointer;
  font-size: 15px;
}
.btn-add-quote:hover{
  background-color: #5d2985;
  color: white;
}
.block-quote-success{
  background-color: #00af4f;
  border: 2px solid #00af4f;
  color: white;
  border-radius: 3px;
  padding: 8px;
  text-align: center;
  font-weight: 900;
  width: 294px;
}
.bx{
  font-size: 27px;
  position: relative;
  top: 3px;
  margin-left: 5px;
  color: #2e6ba3;
}
.body-block-right-subtitle{
  font-weight: 400;
  font-size: 15px;
  margin-top: 10px;
}
.main-subtitle span{
  font-weight: 800;
}
.main-text{
  font-size: 30px;
  color: rgb(88, 43, 121);
  text-align: center;
  margin-top: 50px;
  font-weight: 600;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}
.main-text span{
  font-family: "Inter", Arial, Helvetica, sans-serif;
}
.cards{
  flex-wrap: wrap;
}
.card{
  border: 1px solid black;
  margin: 40px 30px;
  padding: 10px 0;
  width: 138px;
  position: relative;
  height: 130px;
}
.card:hover{
  background-color: #f0f2f1;
}
.card img{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
footer{
  background-color: #572b78;
  font-family: "Asap", serif;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.footer-block{
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}
.footer-logo{
  width: 40%;
}
.footer-main{
  width: 60%;
}
.footer-info{
  width: 33.333%;
}
.footer-info-title{
  color: #ebc018;
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}
.footer-info-item{
  color: white;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 25px;
}
.btn.disabled{
  background-color: #c7c7c7;
  border-color:  #c7c7c7;
  color: white;
}
.btn-account-capricorn{
  background-color: white;
  color: #6f309f;
  margin-top: 20px;
}
.btn-account-capricorn:hover{
  background-color: #6f309f;
  color: white;
}
.capricorn-account-block-elem-name span{
  color: red;
  font-size: 18px;
}
.capricorn-account-block-elem-name{
  margin-top: 8px;
}
.capricorn-account-block-elem-input .input-capricorn-num{
  margin-top: 3px;
}
.input-capricorn-num[readonly]{
  border-color: rgba(0, 0, 0, .25);
  color: rgba(0, 0, 0, .25);
}
.body-block-left-item-input >>> .multiselect__content-wrapper .multiselect__option{
  font-size: 13px;
  height: 32px;
}
input{
  font-size: 13px;
}
@media (max-width: 1280px) {
  .left-block{
    width: auto;
  }
  .right-banner{
    display: none;
  }
  .good-wizard-block >>> .sticky .wizard__divider{
    display: block;
  }
  .body-block-left{
    min-width: auto;
  }
  .body-block-right{
    min-width: auto;
  }
  .wrapper-statewide{
    width: 100%;
  }
}
@media (max-width: 950px) {
  .right-banner{
    display: none;
  }
  .wrapper-statewide{
    margin-top: 20px;
  }
}
@media (max-width: 767px) {
  .body-block{
    display: block !important;
  }
  .body-block-left{
    width: 100%;
    margin-right: 0;
    border-right: 0;
    border-bottom: 5px solid #6f309f;
  }
  .body-block-right{
    width: 100%;
    margin-top: 25px;
  }
  .body-block-left-mobile-num-parts{
    display: block;
    color: #6f309f;
    height: 35px;
    font-size: 18px;
    text-align: center;
    width: 35px;
    background-color: #e0d4ea;
    border-radius: 999px;
    padding: 5px;
    font-weight: 900;
  }
  .body-block-left .body-block-left-item-input .bxs-camera{
    /*display: none;*/
  }
}
@media (max-width: 700px) {
  .body-block{
    margin-top: 0;
  }
  .wrapper-statewide{
    margin-top: 0;
    width: 100%;
  }
}
@media (max-width: 500px) {
  .body-block-left{
    min-width: 310px;
  }
  .body-block-left-item-input{
    min-width: 230px;
  }
  .available-right-block{
    width: 230px;
  }
  .body-block{
    padding: 5px 0;
  }
}

.red-blinker {
  animation: blinker 2s linear infinite;
}
@keyframes blinker {
  0% {
    border-color: red;
  }
  50% {
    border-color: rgba(0, 0, 0, .25);;
  }
}
</style>
